import { Layer } from '@deck.gl/core';
import allPlanesPng from '../../img/all-planes-map-sdf.png';
import allPlanesJson from '../../img/all-planes-map.json';
import { iconSizeScale } from '../IconSize';
import { iconPixelSize, IconType } from '../IconType';
import { ParkedFlight } from '../parked/parked-updater';
import { DeckLayerCreator } from './deck-layer-creator';
import { DeckOverlayPlugin } from './deck-overlay-plugin';
import { FlightsIconLayer } from './layers/flight/flight-icon-layer';

export class DeckParked extends DeckLayerCreator {
    constructor(plugin: DeckOverlayPlugin) {
        super(plugin);
    }

    createLayers(): Layer[] {
        if (!this.props?.flights.visible || !this.props?.flights.parked.visible) {
            return [];
        }
        const { showShadow, iconSize } = this.props.flights.active;

        return [
            new FlightsIconLayer<ParkedFlight>({
                id: 'parked-flights',
                data: this.plugin.parkedUpdater.items,
                isGlobeView: this.useGlobeView,
                sdfParams: this.plugin.planeSdfParams,
                outlineColor: [250, 125, 0, 255],
                getColor: [250, 125, 0, 255],
                shadowColor: [0, 0, 0, 0.2],
                showShadow: showShadow,
                billboard: false,
                sizeUnits: 'pixels',
                getPosition: (d) => [d.position!.lng, d.position!.lat],
                sizeScale: iconSizeScale(iconSize) * 1.4,
                getSize: iconPixelSize(IconType.largeJet),
                getAngle: 0,
                iconMapping: allPlanesJson,
                iconAtlas: allPlanesPng,
                getIcon: () => IconType.largeJet.toString(),
                getIsHidden: 0,
                pickable: true,
                updateTriggers: {
                    all: [this.plugin.parkedUpdater.version]
                },
                parameters: this.plugin.getRenderingParams({
                    cullMode: 'front'
                })
            })
        ];
    }
}
